import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getClients
 */

export interface ExportClientsParams {
	query?: string
	active?: boolean
	suspended?: boolean
	onBoarding?: boolean
	onBoardingStep?: number
	plan?: 'free' | 'paid'
	platformMode?: 'live' | 'demo'
	archived?: boolean
	fieldFilters?: string
}

/**
 * API call to export client from the WhatCX Application
 * @param params GetClientsParams - Options for the API call
 * @returns Blob - Response object returned from the server
 */

export const exportClient = async (params: ExportClientsParams) => {
	try {
		const { data } = await axios.get<Blob>('/client', {
			params: {
				query: params.query,
				active: params.active,
				suspended: params.suspended,
				onBoarding: params.onBoarding,
				onBoardingStep: params.onBoardingStep,
				should_export: true,
				plan: params.plan,
				platformMode: params.platformMode,
				archived: params.archived,
				fieldFilters: params.fieldFilters,
			},
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default exportClient
